module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A MARINER BOOK")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("HOUGHTON MIFFLIN COMPANY")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Boston New York")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("First Mariner Books edition "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("2003")]), _c('a', {
    attrs: {
      "id": "piv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Copyright © 1997 by Peter Ho Davies"), _c('br'), _vm._v("\nAll rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from"), _c('br'), _vm._v("\nthis book, write to Permissions, Houghton Mifflin Company,"), _c('br'), _vm._v("\n215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _c('br'), _vm._v("\nDavies, Peter Ho, date"), _c('br'), _vm._v("\nThe ugliest house in the world . stories / Peter Ho Davies."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\nContents . The ugliest house in the world—"), _c('br'), _vm._v("\nI don't know, what do you think?—Coventry—A Union"), _c('br'), _vm._v("\n—Relief—Safe—Buoyancy—The silver screen."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 0-395-92480-4"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-3959-2480-8"), _c('br'), _vm._v("\nI. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("PR")]), _vm._v("6054.A89145U4 1997"), _c('br'), _vm._v("\n813'.54—dc2I 97-12873 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("CIP")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("DOH")]), _vm._v(" 10 9 8 7 6 5 4 3")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("The following stories appeared in slightly different form in these"), _c('br'), _vm._v("\npublications: \"The Ugliest House in the World\" in "), _c('em', [_vm._v("Antioch Review,")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Critical Quarterly")]), _vm._v(" (U.K.), and "), _c('em', [_vm._v("The Best American Short Stories 1995;")]), _c('br'), _vm._v("\n\"Relief\" in "), _c('em', [_vm._v("The Paris Review;")]), _vm._v(" \"Safe\" in "), _c('em', [_vm._v("Agni,")]), _vm._v(" \"I Don't Know, What"), _c('br'), _vm._v("\nDo You Think?\" in "), _c('em', [_vm._v("The Greensboro Review;")]), _vm._v(" \"Buoyancy\" in "), _c('em', [_vm._v("Story,")]), _c('br'), _vm._v("\n\"The Silver Screen\" in "), _c('em', [_vm._v("Harvard Review")]), _vm._v(" and "), _c('em', [_vm._v("The Best American")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Short Stories")]), _vm._v(" 1996")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("For my parents")]), _c('a', {
    attrs: {
      "id": "pv"
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', {
    staticClass: "fronttitle"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Thanks are due to everyone who has read and commented on these stories but especially to Lynne Raughley, Marshall N. Klimasewiski, Fred Leebron, Kathryn Rhett, and Janet Silver. I am also grateful to the Henfield Foundation and the Fine Arts Work Center in Provincetown for their generous support during the writing of this book."), _c('a', {
    attrs: {
      "id": "pvi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("A number of sources were helpful for the historical stories in this collection, but the following books and their authors proved especially valuable: "), _c('em', [_vm._v("The Washing of the Spears,")]), _vm._v(" by Donald R. Morris; "), _c('em', [_vm._v("The North Wales Quarrymen 1874-1922,")]), _vm._v(" by R. Merfyn Jones; "), _c('em', [_vm._v("In Patagonia,")]), _vm._v(" by Bruce Chatwin; and "), _c('em', [_vm._v("The War of the Running Dogs,")]), _vm._v(" by Noel Barber. Any inaccuracies are my responsibility, as, of course, are the occasional historical liberties I've taken.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "center"
  }, [_vm._v("\"Use every man after his desert, and who shall 'scape whipping?\""), _c('a', {
    attrs: {
      "id": "pvii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Hamlet")]), _vm._v(" II, ii")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', {
    staticClass: "fronttitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("THE UGLIEST HOUSE IN THE WORLD")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/c01#p1"
    }
  }, [_vm._v("[>]")]), _c('a', {
    attrs: {
      "id": "pix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("RELIEF")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c02#p27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A UNION")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c03#p47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("SAFE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c04#p127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("I DON'T KNOW, WHAT DO YOU THINK?")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c05#p145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("COVENTRY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c06#p165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("BUOYANCY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c07#p191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("THE SILVER SCREEN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c08#p205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b4b7313","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front.vue
// module id = 57
// module chunks = 0